export default {
  table: {
    id: "ID",
    name: "Name",
    users: "Users",
    usersCount: "Number of users",
    fullname: "Full name",
    email: "Email",
    role: "Role",
  },
  actions: {
    users: "Team users",
  },
  form: {
    name: "Team name",
    users: "Users",
    addUser: "Add user",
    userId: "User ID",
    selectUser: "Select user",
    searchUser: "Search user",
    selectRole: "Select role",
    add: "Add",
  },
  roles: {
    leader: "Leader",
    member: "Member",
  },
  confirmDelete: "Are you sure you want to delete this team?",
  confirmRemoveUser: "Are you sure you want to remove this user from the team?",
};
